import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.User.List.IRequest;
type Response = Api.Core.User.List.IResponse;
type Headers = Api.Core.User.List.IHeaders;
const url = '/api/Management/User';
export default async function userListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
